module.exports = __webpack_public_path__ + "img/note-message.ae950d62.svg";